import React, { useState } from 'react'

import Button from '@react/react-spectrum/Button'
import Dialog from '@react/react-spectrum/Dialog'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import Textarea from '@react/react-spectrum/Textarea'

export default function ({ name, buttonLabel, defaultValue, disabled, onChange }) {
  return (
    <ModalTrigger>
      <Button disabled={disabled}>{buttonLabel || 'Open Editor'}</Button>
      <PlainTextDialog name={name} defaultValue={defaultValue} disabled={disabled} onChange={onChange} />
    </ModalTrigger>
  )
}

function PlainTextDialog({ name, defaultValue, disabled, onChange, ...otherProps }) {
  const [_value, _setValue] = useState(defaultValue)
  return (
    <Dialog
      confirmLabel='Save'
      cancelLabel='Cancel'
      disabled={disabled}
      onConfirm={() => onChange(_value)}
      {...otherProps}
      role='dialog'
    >
      <Textarea
        name={name}
        value={_value}
        disabled={disabled}
        onChange={(v) => _setValue(v)}
        style={{ width: '500px', height: '500px' }}
      />
    </Dialog>
  )
}
